import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { EmployeeService } from '../../services/employee.service';
import { RoleService } from '../../services/role.service';
import { DepartmentService } from '../../services/department.service';

import { Utils } from '../../util';
import { MaterializeAction, toast } from 'angular2-materialize';
import { Upload } from '../../services/upload/upload';
import { Subject } from 'rxjs/Subject';
import { WebcamInitError, WebcamImage } from 'ngx-webcam';
import { Observable } from 'rxjs/Observable';
import { CompanyService } from '../../services/company.service';

@Component({
    selector: 'app-display-employee',
    templateUrl: './display-employee.component.html',
    styleUrls: ['./display-employee.component.css', '../../app.component.css']
})

export class DisplayEmployeeComponent implements OnInit, OnDestroy {

    employee: any = {};
    company: any = {};

    id: string;

    igeSubs: any;
    comSub: any;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private service: EmployeeService,
        private roleService: RoleService,
        private departmentService: DepartmentService,
        private companyService: CompanyService
    ) {
        this.activatedRoute.params.subscribe(parameters => {

            this.id = parameters['id'];

            this.igeSubs = this.service.getEmployeeData(this.id).subscribe(([employeeObj]) => {

                this.employee = employeeObj;
                this.employee.fullName = `${this.employee.name} ${this.employee.lastName}`;

                if (this.employee.admissionDate) {
                    this.employee.admissionDate = Utils.convertDatefromStringtoISOString(this.employee.admissionDate);
                }

                this.employee.subsidiaryName = this.employee.subsidiaryObj.subsidiaryName;
                this.employee.jobName = this.employee.jobObj.jobName + ' - ' + this.employee.jobObj.baseSalary;

                if (this.employee.roleId) {
                    let igrSubs = this.roleService.getRole(this.employee.roleId).subscribe(roleObj => {
                        igrSubs.unsubscribe();

                        this.employee.roleName = roleObj.name;
                    });
                }

                if (this.employee.departmentId) {
                    let igdSubs = this.departmentService.getDepartment(this.employee.departmentId).subscribe(departmentObj => {
                        igdSubs.unsubscribe();

                        this.employee.departmentName = departmentObj.name;
                    });
                }

                if (Math.floor(this.employee.transportArrive) !== 3) {
                    switch (this.employee.transportArrive) {
                        case 1:
                            this.employee.transportArriveName = 'Por su propio medio';
                            break;
                        case 2:
                            this.employee.transportArriveName = 'Duerme en las instalaciones';
                            break;
                        case 4:
                            this.employee.transportArriveName = 'Transporte de la empresa';
                            break;
                        default:
                            this.employee.transportArriveName = 'No especificado';
                            break;
                    }
                } else {
                    let igcSubs = this.service.getEmployee(this.employee.carrierId).subscribe(carrierObj => {
                        igcSubs.unsubscribe();

                        this.employee.transportArriveName = this.employee.transportArrive == 3 ? 'Es trasladado por un transportista local' : 'Es transladado por un transportista foráneo';
                        this.employee.carrierName = carrierObj.name + ' ' + carrierObj.lastName;
                    });
                }

                if (this.employee.applyInPrompterReport !== undefined) {
                    this.employee.applyInPrompterReport = (this.employee.applyInPrompterReport) ? 'Sí' : 'No';
                }
                if (this.employee.applyInSupervisorReport !== undefined) {
                    this.employee.applyInSupervisorReport = (this.employee.applyInSupervisorReport) ? 'Sí' : 'No';
                }
                if (this.employee.applyInCheckClock !== undefined) {
                    this.employee.applyInCheckClock = (this.employee.applyInCheckClock) ? 'Sí' : 'No';
                }
                this.employee.applySecurityReport = this.employee.applySecurityReport ? 'Sí' : 'No';
            });
        });
        this.comSub = companyService.getCompany().subscribe(company => {
            this.company = company;
        });
    }

    ngOnInit() {
    }
    ngOnDestroy() {
        this.igeSubs.unsubscribe();
        this.comSub.unsubscribe();
    }

    onCredential() {
        if (!this.employee.imageUrl) {
            return toast('Por favor agregue una fotografía al empleado para imprimir la credencial.', 4000);
        }
        if (!this.employee.internalKey || this.employee.internalKey.toString().trim() === '') {
            return toast('Por favor agregue la llave interna (Folio) al empleado para imprimir la credencial.', 4000);
        }

        const form = document.getElementById("email_form") as HTMLFormElement;
        if (form) {
            form['sendEmail'].value = 'false';
            form.submit();
        }
    }

    get pdfJson() {
        return JSON.stringify(this.employee && this.company ? { ...this.employee, company: this.company } : {});
    }

    ////////////////////////////////////////////////////////////////////////////////////////////////////IMAGE
    image: HTMLImageElement = new Image(2, 1);

    modalActionsImage = new EventEmitter<string | MaterializeAction>();
    modalParamsImage = [{ dismissible: true }];

    openModalImage() {
        this.image = new Image();
        this.image.src = this.employee.imageUrl;
        this.modalActionsImage.emit({ action: 'modal', params: ['open'] });
    }
    closeModalImage() {
        this.modalActionsImage.emit({ action: 'modal', params: ['close'] });
    }

    uploadFile(event) {
        var selectedFile: File = event.target.files[0];
        var currentUpload: Upload = new Upload(selectedFile);

        this.service.convertUploadImage(currentUpload, this.id);
    }

    deleteFile() {
        this.service.deleteImage(this.id, this.employee.imageName);
        this.closeModalImage();
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////IMAGE


    ////////////////////////////////////////////////////////////////////////////////////////////////////SNAPSHOT
    //https://www.npmjs.com/package/ngx-webcam
    modalActionsSnapshot = new EventEmitter<string | MaterializeAction>();
    modalParamsSnapshot = [{ dismissible: true }];

    openModalSnapshot() {
        this.modalActionsSnapshot.emit({ action: 'modal', params: ['open'] });
    }
    closeModalSnapshot() {
        this.modalActionsSnapshot.emit({ action: 'modal', params: ['close'] });
    }

    trigger: Subject<void> = new Subject<void>();
    errors: WebcamInitError[] = [];
    triggerSnapshot(): void {
        this.trigger.next();
    }
    handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
        console.log(this.errors)
    }
    handleImage(webcamImage: WebcamImage): void {
        let blob: any;
        let xhr = new XMLHttpRequest();
        xhr.open("GET", webcamImage.imageAsDataUrl);
        xhr.responseType = "blob";
        xhr.onload = () => {
            blob = xhr.response;
            blob.name = 'webcamPicture.jpeg';
            let file: File = <File>blob;
            var currentUpload: Upload = new Upload(file);
            this.service.uploadImage(currentUpload, this.id);
        };
        xhr.send();
        this.closeModalSnapshot();
    }
    get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }
    ////////////////////////////////////////////////////////////////////////////////////////////////////SNAPSHOT

}
